/*
 * O alerta "Lembrete do marcador" (tipo `canelaBookmarkReminder`), mandado
 * pelo comando agendado quando o horário escolhido chega. Leva ao post
 * marcado; o trecho é o nome do marcador, ou o começo do post sem nome.
 */
import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import { truncate } from 'flarum/common/utils/string';
import { t } from '../../../utils/settings';
export default class BookmarkReminderNotification extends Notification {
  icon() {
    return 'fas fa-bookmark';
  }
  post() {
    return this.attrs.notification.subject() || null;
  }
  href() {
    const post = this.post();
    return post ? app.route.post(post) : '';
  }
  content() {
    const discussion = this.post()?.discussion();
    return t('bookmarks.notification.text', {
      title: discussion ? discussion.title() : ''
    });
  }
  excerpt() {
    const data = this.attrs.notification.content() || {};
    if (data.name) return data.name;
    const plain = this.post()?.contentPlain();
    return plain ? truncate(plain, 200) : null;
  }
}
flarum.reg.add('ramon-canela', 'forum/features/bookmarks/components/BookmarkReminderNotification', BookmarkReminderNotification);